import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  getLanguageDirection,
  normalizeLanguage,
} from "i18n/config";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
  const languages = useMemo(() => Object.values(SUPPORTED_LANGUAGES), []);
  const currentLanguage = SUPPORTED_LANGUAGES[language];
  const isRTL = getLanguageDirection(language) === "rtl";

  const changeLanguage = useCallback(
    (nextLanguage) => {
      const normalizedLanguage = normalizeLanguage(nextLanguage);

      if (normalizedLanguage === language) {
        return Promise.resolve(normalizedLanguage);
      }

      return i18n.changeLanguage(normalizedLanguage);
    },
    [i18n, language],
  );

  const toggleLanguage = useCallback(() => {
    const nextLanguage = language === "ar" ? "en" : "ar";
    return changeLanguage(nextLanguage);
  }, [changeLanguage, language]);

  return {
    language,
    languages,
    currentLanguage,
    isRTL,
    dir: getLanguageDirection(language),
    changeLanguage,
    toggleLanguage,
  };
};
